import { createContext, useContext } from 'react';
import type { MeterDataContextType } from './types';
import { MeasurementRange } from '../../common/chart/types/types';

export const MeterDataContext = createContext<MeterDataContextType>({
  selectedRange: MeasurementRange.DayInHours,
  setSelectedRange: () => {},
  page: 0,
  setPage: () => {},
  fromTo: { from: new Date().toISOString(), to: new Date().toISOString() },
});

export const useMeterDataContext = () => useContext(MeterDataContext);
